module.exports = __webpack_public_path__ + "img/RupiahFileIcon.271a6585.svg";